module.exports = __webpack_public_path__ + "img/formsOktagon.9d9f9207.svg";